/**
 * SaleWisely 在线客服接入：隐藏默认图标，由站内入口调用 showChat。
 * 客服侧只展示会员 ID。
 */

const SALEWISELY_LANG_MAP = {
  zh_cn: "zh",
  zh: "zh",
  zh_tw: "zh-hant",
  zh_hk: "zh-hant",
  en_us: "en",
  en: "en",
  ko_hy: "ko",
  ko: "ko",
  es_spa: "es",
  es: "es",
  yn_yu: "vi",
  vi: "vi",
  idn_yu: "id",
  id: "id",
  ms_my: "ms",
  ms: "ms",
};

function resolveAppLanguage() {
  const raw = String(
    (typeof localStorage !== "undefined" &&
      (localStorage.getItem("lang") || localStorage.getItem("login_display_lang"))) ||
      "zh_cn"
  ).toLowerCase();
  return SALEWISELY_LANG_MAP[raw] || "zh";
}

/** 业务用户 ID（不要用 token） */
export function resolveSaleWiselyUserId(vm) {
  const userInfo =
    (vm &&
      vm.$store &&
      vm.$store.state &&
      (vm.$store.state.userInfo || vm.$store.state.user)) ||
    null;
  const fromInfo =
    (userInfo && (userInfo.id || userInfo.user_id || userInfo.uid)) ||
    (vm && vm.userInfo && (vm.userInfo.id || vm.userInfo.user_id));
  if (fromInfo != null && String(fromInfo).trim()) {
    return String(fromInfo).trim();
  }
  return (
    localStorage.getItem("id") ||
    localStorage.getItem("user_id") ||
    ""
  );
}

export function applySaleWiselyConfig(options = {}) {
  if (typeof window === "undefined") {
    return;
  }
  const language = options.language || resolveAppLanguage();
  window._salewiselyConfig = {
    ...(window._salewiselyConfig || {}),
    hiddenIcon: true,
    language,
    fullscreen: options.fullscreen !== false,
  };
}

export function applySaleWiselyUser(vm, options = {}) {
  if (typeof window === "undefined") {
    return "";
  }
  const userId = String(options.userId || resolveSaleWiselyUserId(vm) || "").trim();
  window._salewiselyUser = userId
    ? {
        userId,
        language: options.language || resolveAppLanguage(),
      }
    : {
        language: options.language || resolveAppLanguage(),
      };
  return userId;
}

function getSdk() {
  return typeof window !== "undefined" ? window.SaleWiselySDK : null;
}

export function waitForSaleWiselySdk(timeoutMs = 8000) {
  return new Promise((resolve) => {
    const ready = getSdk();
    if (ready && typeof ready.showChat === "function") {
      resolve(ready);
      return;
    }
    const started = Date.now();
    const timer = setInterval(() => {
      const sdk = getSdk();
      if (sdk && typeof sdk.showChat === "function") {
        clearInterval(timer);
        resolve(sdk);
        return;
      }
      if (Date.now() - started >= timeoutMs) {
        clearInterval(timer);
        resolve(null);
      }
    }, 120);
  });
}

/**
 * 打开 SaleWisely 聊天窗。成功返回 true。
 */
export async function openSaleWiselyChat(vm, options = {}) {
  applySaleWiselyConfig(options);
  applySaleWiselyUser(vm, options);
  const sdk = await waitForSaleWiselySdk(options.timeoutMs);
  if (!sdk || typeof sdk.showChat !== "function") {
    return false;
  }
  try {
    sdk.showChat();
    return true;
  } catch (error) {
    return false;
  }
}

export function hideSaleWiselyChat() {
  const sdk = getSdk();
  if (sdk && typeof sdk.hideChat === "function") {
    try {
      sdk.hideChat();
    } catch (error) {
      // ignore
    }
  }
}
